import deburr from "lodash/deburr";
const sanitizeStringForUrl = (brand = "") => deburr(
  brand.replace(/['"`´‘’!.&_\-\+]+/gi, " ").trim().toLowerCase().replace(/\s+/gi, "-")
);
export {
  sanitizeStringForUrl
};
//# sourceMappingURL=sanitize-string-for-url.js.map
